import React, { useState, useEffect, Fragment } from 'react';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import Modal from 'react-modal';
import API from '../../services/API';

const StudentPage = () => {
    const [classes, setClasses] = useState([]);
    const [students, setStudents] = useState([]);
    const [pagination, setPagination] = useState({
        current_page: 1,
        total_pages: 1,
        total_students: 0,
        limit: 50
    });
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [imagesModalOpen, setImagesModalOpen] = useState(false);
    const [modalImages, setModalImages] = useState([]);
    const [modalLoading, setModalLoading] = useState(false);
    const [selectedClass, setSelectedClass] = useState('');
    const [classList, setClassList] = useState([]);

    const fetchSchoolAndClasses = async () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        try {
            const response = await API.get(`/school/`, { headers });
            if (response.status === 200) {
                const skkdClasses = response.data.data.filter(school => school.school_id === 'SCH004');
                setClassList(skkdClasses); 
                setClasses(skkdClasses);  // Set classes to display in the table
            } else {
                toast.error('Failed to fetch classes', { autoClose: 5000 });
            }
        } catch (error) {
            console.error('Error fetching classes:', error);
            toast.error('Error fetching class list', { autoClose: 5000 });
        }
    };

    const fetchStudentsByClass = async (classId) => {
        setModalLoading(true);
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        try {
            const response = await API.get(`/aiFace/getAllImagesByClass/${classId}`, { headers });
            if (response.data.response_code === 1000) {
                console.log(response.data)
                const classStudents = response.data.data; // Assuming all students in the class are returned
                setModalImages(classStudents.map((student) => ({
                    student_id: student.student_id,
                    image: student.random_image,  // Random image of each student
                    first_name: student.first_name
                })));
                setImagesModalOpen(true);
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
            }
        } catch (error) {
            console.log(classId,error)
            toast.error("Failed to fetch class students. Please try again.", { autoClose: 5000 });
        } finally {
            setModalLoading(false);
        }
    };

    const columns = [
        {
            name: 'Class Name',
            selector: (row) => row.class_name || 'N/A',
            sortable: true,
            center: true,
        },
        {
            name: 'Number of Students',
            selector: (row) => row.total_students,
            sortable: true,
            center: true,
        },
        {
            name: 'View Students',
            cell: (row) => (
                <button
                    className="btn btn-info btn-sm"
                    onClick={() => fetchStudentsByClass(row.class_id)}
                    disabled={modalLoading}
                >
                    {modalLoading ? 'Loading...' : 'View Students'}
                </button>
            ),
            center: true,
        }
    ];

    const handleSearchChange = (e) => setSearchQuery(e.target.value);

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        // You can filter classes if needed here based on the search query
        // For now, it's just a placeholder
        setClasses(classList.filter(cls => cls.class_name.toLowerCase().includes(searchQuery.toLowerCase())));
    };

    useEffect(() => {
        fetchSchoolAndClasses();
    }, []);

    return (
        <Fragment>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card rounded-25">
                            <div className="card-header rounded-25">
                                <h5>Classes</h5>
                                <div className="d-flex justify-content-end mt-2">
             
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <DataTable
                                        columns={columns}
                                        data={classes}
                                        striped
                                        persistTableHead
                                        progressPending={loading}
                                        pagination
                                        paginationServer
                                        paginationTotalRows={classes.length}
                                        paginationDefaultPage={pagination.current_page}
                                        paginationPerPage={pagination.limit}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal
                    isOpen={imagesModalOpen}
                    onRequestClose={() => setImagesModalOpen(false)}
                    contentLabel="Class Students"
                    ariaHideApp={false}
                    style={{
                        content: {
                            maxWidth: '800px',
                            margin: 'auto',
                            padding: '20px',
                            borderRadius: '10px',
                        },
                    }}
                >
                    <h2>Class Students</h2>
                    <div className="images-grid" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                        {modalImages.map((theImage, index) => (
                            <div key={index} style={{ width: '200px', textAlign: 'center' }}>
                                <img
                                    src={theImage.image}
                                    alt={`Student Image ${index + 1}`}
                                    style={{ width: '100%', height: '200px', borderRadius: '5px', objectFit: 'cover' }}
                                />
                                <p>{theImage.first_name}</p>
                            </div>
                        ))}
                    </div>
                    <button className="btn btn-secondary mt-3" onClick={() => setImagesModalOpen(false)}>Close</button>
                </Modal>
            </div>
        </Fragment>
    );
};

export default StudentPage;
